import { supabase } from '@/lib/supabase';
import { Profile } from '@/shared/types/api';

export const getUserProfile = async (profileId: string): Promise<Profile> => {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', profileId)
    .single();

  if (error) {
    throw error;
  }

  return data;
};
